import {
  CssBaseline,
  Typography,
  Container,
  Box,
  Grid,
  Button,
  FormControlLabel,
  Checkbox,
  TextField,
  Link,
  Alert
} from "@mui/material";
import React, { useState, FC } from "react";
import Logo from "../../assets/InFind.png";
import { RouteComponentProps } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";

const topdiv = {
  height: "100vh",
  padding: "10px",
  background: "#cceeff",
};
type LoginComponentProps = RouteComponentProps;

const Login: FC<LoginComponentProps> = ({ history }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState('');

  const submitData = (data: any) => {
    let params = {
      email: data.email,
      password: data.password,
    };
    console.log(data);
    axios
      .post(
        "http://34.94.96.59:5050/infindbot/login",
        params
      )
      .then(function (response) {
        console.log('response:', response);

        
        if (response.data.error) {
          setErrorMessage(response.data.error);
        } else {
          //localStorage.setItem('session_id', 'test1');
          localStorage.setItem('session_id', response.data.content.user.user_id);
          localStorage.setItem('user', JSON.stringify(response.data.content));
          history.push('/');
          window.location.reload();
        }
      })
      .catch(function (error) {
        console.log(error);
        setErrorMessage('Problem of inserting credentials to database.')
      });
  };

  return (
    <div style={topdiv}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            background: "#fff",
            borderRadius: "30px",
            padding: "30px",
          }}
        >
          {<a href="http://infind.ai">
            <img height="50px" src={Logo} alt="logo" />
          </a>}
          <Typography component="h1" variant="h5">
            Log In
          </Typography>
         {errorMessage && (
        <Alert severity="error" onClose={() => setErrorMessage('')}>
          {errorMessage}
        </Alert>
      )}
          <form noValidate>
            <Box component="form" noValidate sx={{ mt: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    autoFocus
                    id="email"
                    label="Email Address"
                    autoComplete="email"
                    value={email}
                    {...register("email", {
                      required: "Email is required!",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: "Invalid email address!",
                      },
                    })}
                    onChange={(e) => setEmail(e.target.value)}
                    error={!!errors.email}
                    helperText={(errors.email?.message as any) }
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    {...register("password", {
                      required: "Password is required!",
                    })}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={!!errors.password}
                    helperText={(errors.password?.message as any) }
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={<Checkbox value="remember" color="primary" />}
                    label="Remember me"
                  />
                </Grid>
              </Grid>
              <Button
                type="button"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={handleSubmit(submitData)}
              >
                Log In
              </Button>
              <Grid container justifyContent="center">
                <Grid item>
                <Link href="/demo/infindwebapp/register" variant="body2">
                    Don't have an account register here
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </form>
        </Box>
      </Container>
    </div>
  );
};
export default Login;